import { render, staticRenderFns } from "./OnboardingCard.vue?vue&type=template&id=46782337"
import script from "./OnboardingCard.vue?vue&type=script&lang=js"
export * from "./OnboardingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports